import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import 'animate.css/animate.min.css';
import '../css/trimmis.scss';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

class MobileMenu extends Component {

  render() {
    const menuClass = this.props.toggleWith ? 'trimmis-mobile-menu' : 'trimmis-mobile-menu collapse';
    const styles = {
      height: "100vh"
    };

    return (
        <div className={menuClass} style={styles}>
          <i className="cancel-menu glyphicon glyphicon-remove animated flipInX" onClick={() => this.props.closeMenu()}></i>
          <div className="mobile-menuitem-holder">
            {this.props.menuItems.map((object, i) => {
              return <Link key={i} className="trimmis-menu-item-mobile" to={object.link}>{object.text}</Link>
            })}
          </div>
          <div className="mobile-menu-bottom-content">
            <Link to={"/book-time"} className="trimmis-button col-xs-12 content-margin-20">VARAA AIKA</Link>
            <p className="menu-paragraph">tai soita <span className="bold-number"><Link to={"tel:09 123 4567"}>09 123 4567</Link></span></p>
          </div>
        </div>
    );
  }
}

MobileMenu.propTypes = {
  menuItems: PropTypes.array,
  toggleWith: PropTypes.bool,
  closeMenu: PropTypes.func
};

export default MobileMenu;



// WEBPACK FOOTER //
// ../components/MobileMenu.js